<template>
  <div class="container" style="max-width: 100%">
    <!-- Heading -->
    <!-- <h2 class="text-center mt-5">Notes</h2> -->
    <!-- Input -->
    <div id="output" class="textfield mt-5" style="max-width: 100%">
      <textarea type="text" v-model="note" placeholder="Enter your notes here..." class="input-area w-50 form-control"></textarea>
      <button class="save btn rounded-0" @click="saveNote">
        Save
      </button>
    </div>
    <!-- Notes Div -->
    <div class="notes">
    <div class="notes-div" v-for="(note, index) in notes" :key="index">
      <div class="note-div">
        <span class="note">{{ note.note }}</span>
        <div class="note-details">
          <div class="time-and-delete">
            <div class="note-owner-and-time">
              <span class="note-owner">{{ note.created_by.first_name+ " " + note.created_by.last_name}}</span>
              <span class="dot">.</span>
              <span class="note-time">{{ `${note.created}` | moment("DD/MM/YY, h:mm a") }}</span>
            </div>
            <div>
              <span @click="deleteNote(index)" class="remove fa fa-trash-o pointer"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <el-pagination
      style="margin-top: 25px; margin-left: -10px;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :total="total_pages"
      layout="sizes, prev, pager, next"
      :page-size="offset"
  >
  </el-pagination>
  </div>
</template>

<script>
import axios from 'axios';


export default {
  props: ['lineItemId'],
  data() {
    return {
      note: "",
      notes: [],
      total_pages: 0,
      currentPage: 1,
      offset: 20,
      domainId : this.domId,
    };
  },
  created: function() {
    this.getNotes();
    },
  methods: {
    
    getNotes(){
      let vm = this;
      console.log(this.lineItemId)
      axios.get(BASE_URL + `bidder/v1/notes/?lineitem_id=${this.lineItemId}`)
      .then(response => {
        console.log("response.data",response.data)
        vm.notes = response.data.results;
      })
      .catch(error => {
        console.log(error);
      });
    },
  
    deleteNote(index) {
      let vm = this;
      // this.notes.splice(index, 1);
      axios.delete(BASE_URL + `bidder/v1/notes/${this.notes[index].id}/`)
      this.$confirm('Are you sure to delete this note?', 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'warning',
            })
      .then(response => {
        vm.getNotes();
      })
      .catch(error => {
        console.log(error)
      })
    },

    saveNote() {
      let vm = this;
      axios.post(BASE_URL + `bidder/v1/notes/`, {
        note: this.note,
        lineitem: this.lineItemId,
      })
        .then(response => {
          vm.getNotes();
          vm.note = "";
        })
        .catch(error => {
          console.log(error);
        });
    },
    getLineItemNotes(pageNum = 1){
      let vm = this;
      axios.get(BASE_URL + `bidder/v1/notes/?lineitem_id=${this.lineItemId}&page=${pageNum}&offset=${this.offset}`)
      .then(response => {
        console.log("response.data",response.data)
        vm.notes = response.data.results;
        this.total_pages = response.data.count;
      })
      .catch(error => {
        console.log(error);
      });
    },
    handleCurrentChange(val) {
            console.log(`Current page ${val}`);
            this.getLineItemNotes(val);
            this.currentPage = val;
    },
    handleSizeChange(val) {
            console.log('Size changed: ', val);
            this.offset = val;
            this.getLineItemNotes(1);
            this.currentPage = 1;
    },
    clearContent(){
    console.log("working",document.getElementById("output").value)
    // document.getElementById("output").value='';
    },
  //   eraseText() {
  //   document.getElementById("clear").value = "";
  // },
  },
  watch: { 
      	lineItemId: function(newVal, oldVal) { 
          this.getNotes()// watch it
          console.log('Prop changed: ', newVal, ' | was: ', oldVal)
        }
      }
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}

.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.line-through {
  text-decoration: line-through;
}

.textfield {
  margin-bottom: 12px;
  margin-top: 20px;
  justify-content: flex-end;
  /* border-radius: 5px; */
}

input {
  border: 0;
  box-shadow: 0;
}

button {
  box-shadow: 0;
  border-radius: 0;
  margin-top: 10px;
}

.dot{
  font-size: xx-large;
  margin-top: -10px;
  margin-left: 18px;
  color: #d9d9d9;
}
.table{
  border-radius: 4px;
}
.input-area{
  border: 1px solid rgb(211, 211, 211);
  border-radius: 4px;
  height: 80px;
} 
.save{
  float: right;
  margin-bottom: 20px;
  border-radius: 4px;
  width: 120px;
  height: 40px;
  /* font-size: medium; */
  font-weight:bold;
  margin-left: 10px;
  color: white;
  background-color: #80bf73;
}
.clear{
  float: right;
  margin-bottom: 20px;
  border-radius: 4px;
  width: 120px;
  height: 40px;
  /* font-size: medium; */
  font-weight:bold;
  margin-left: 10px;
  color: #666666;
  background-color: #f5f5f5;
}

.header{
  color: gray;
  font-weight: bold;
}
.table-head{
  background-color: #f0eef5;
}
.note {
  padding-bottom: 60px;
  font-size: 15px;
}
.user {
  width: 20%;
}
.date{
  width: 14%;
}
.time{
  width: 12%;
}
.delete{
  width: 8%;
}
.remove{
  font-size: 17px;
  /* font-size: small; */
  /* font-weight: bold; */
}
.total-width {
  width: 90%;
  word-wrap: break-word;
}

.note-details{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.notes{
  margin-top: 60px;
}
.notes-div{
  border: 1px solid #e8e7ea;
  padding: 12px;
  padding-bottom: 17px;
  border-radius: 4px;
  height: auto;
  margin-bottom: 12px;
}

.note-div{
  align-items: center;
}
.note-details{
  display: flex;
  flex-direction: row;
}
.time-and-delete{
  margin-bottom: -10px;
  margin-top: 30px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.note-owner-and-time{
  display: flex;
  justify-content: space-between;
}
.note-owner{
  /* margin-right: -150px; */
  color: rgb(123, 120, 120);
  font-size: 14px;
}

.note-time{
  margin-left: 20px;
  color: rgb(123, 120, 120);
}
.delete-icon{
  
  margin-left: 220px;
}
</style>


// WEBPACK FOOTER //
// AdspotNotes.vue?372931a9